var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cpt_name)?_c(_vm.cpt_name,{ref:"cpt",tag:"component",on:{"close":_vm.close}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }